import React, { useEffect } from "react";
import { Card, List, Avatar, Badge, Typography, Empty, Table } from "antd";
import styled from "styled-components";
import { CALL_API } from "common/API";
import { useSelector } from "react-redux";
import { getClientid, getUserInfo } from "redux/selectors";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { STATUS_CODE } from "common/Constants";

const { Text, Title } = Typography;

const Wrapper = styled(Card)`
  height: 100%;
  min-height: 420px; // ← ensures consistent card height
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px;
  border: none;

  .ant-card-body {
    height: 100%;
    padding: 16px;
    display: flex;
    flex-direction: column;

    @media (min-width: 576px) {
      padding: 20px 24px;
    }
  }

  .task-container {
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .task-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .task-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 10px 0;
  }

  .task-left {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    flex: 1;
  }

  .task-left input {
    margin-top: 3px;
  }

  .task-text {
    font-size: 13px;
    color: #111827;
    line-height: 1.4;
  }

  .task-right {
    text-align: right;
    min-width: 90px;
  }

  .due-label {
    display: block;
    font-size: 11px;
    color: #6b7280;
  }

  .due-date {
    font-size: 12px;
    color: #6b7280;
  }

  .due-date.overdue {
    color: #dc2626;
    font-weight: 500;
  }
`;

const MyTaskList = () => {
  const { t } = useTranslation();
  const [tasks, setTasks] = React.useState([]);
  const userInfo = useSelector(getUserInfo);

  // const tasks = [
  //   {
  //     id: 1,
  //     text: "To generate atleast 3 main leads for sales",
  //     due: "15th Aug 2024",
  //     overdue: false,
  //   },
  //   {
  //     id: 2,
  //     text: "To generate atleast 3 main leads for sales To generate atleast 3 main leads for sales",
  //     due: "15th Aug 2024",
  //     overdue: true,
  //   },
  //   {
  //     id: 3,
  //     text: "To generate atleast 3 main leads for sales",
  //     due: "15th Aug 2024",
  //     overdue: false,
  //   },
  //   {
  //     id: 4,
  //     text: "To generate atleast 3 main leads for sales",
  //     due: "15th Aug 2024",
  //     overdue: false,
  //   },
  //   {
  //     id: 5,
  //     text: "To generate atleast 3 main leads for sales To generate atleast 3 main leads for sales",
  //     due: "15th Aug 2024",
  //     overdue: true,
  //   },
  //   {
  //     id: 5,
  //     text: "To generate atleast 3 main leads for sales To generate atleast 3 main leads for sales",
  //     due: "15th Aug 2024",
  //     overdue: true,
  //   },
  //   {
  //     id: 5,
  //     text: "To generate atleast 3 main leads for sales To generate atleast 3 main leads for sales",
  //     due: "15th Aug 2024",
  //     overdue: true,
  //   },
  // ];

  const getTask = async () => {
    try {
      const { code, tasks } = await CALL_API(
                `tasks/mine?userid=${userInfo?.userid}`,
                "get",
                {
                  
                }
              );
      if (code === STATUS_CODE.SUCCESS) {
        setTasks(
          tasks|| []
        );
      }
    } catch (err) {
      console.error("Error fetching task:", err);
    }
  };

  useEffect(() => {
    getTask();
  }, []);

  return (
    <Wrapper>
      {/* Header */}
      <div className="task-container">
        <h3 className="task-title">{t("My Task")}</h3>
        <Table dataSource={tasks} pagination={false} scroll={{ y: 340 }}>
          <Table.Column
            title={t("Task Id")}
            dataIndex="id"
            key="id"
            width={"30%"}
          />
          <Table.Column
            title={t("Task")}
            width={"40%"}
            dataIndex="title"
            key="title"
          />
          <Table.Column
            title={t("Deadline")}
            dataIndex="due_date"
            key="due_date"
            width={"30%"}
            render={(date) =>
              dayjs(date).isValid() ? dayjs(date).format("D MMM YYYY") : "-"
            }
          />
          
           
        </Table>
        {/* <div
          style={{ overflowY: "scroll", height: "340px", paddingRight: "8px" }}
        >
          {tasks.length === 0 ? (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          ) : (
            <>
              {tasks.map((task) => (
                <div
                  className="task-row"
                  key={`${task?.trackingclientid}-${task?.trackingid}`}
                >
                  <div className="task-left">
                    <p className="task-text">{task?.trackingclientid}</p>
                  </div>

                  <div className="task-left">
                    <p className="task-text">{task?.title}</p>
                  </div>

                  <div className="task-right">
                    <span
                    >
                      {dayjs(task.deadline).format("D MMM YYYY")}
                    </span>
                  </div>
                </div>
              ))}
            </>
          )}
        </div> */}
      </div>
    </Wrapper>
  );
};

export default MyTaskList;
